import React from 'react'
import Marquee from "react-fast-marquee";
import { Row, Col, Container } from "react-bootstrap";
import ClientGallery from '../ClientGallery';

export default function Clients() {
    return (
        <section className='padding-section-large'>
            <Container className="clients">
                <Row className=''>
                    <Col md={9}>
                        <h2 className="heading-style-h2 pb-3">Trusted by Those Who <br /><span className="text-gradient-1">Value Consistency </span></h2>
                        <h5 className='heading-style-h5 pb-5'>From growing businesses to established organizations, our clients rely on us for dependable execution and long-term collaboration. </h5>
                    </Col>
                </Row>
            </Container>
            <Container fluid className="clients">
                <Row>
                    <Marquee speed={50}>
                        <ClientGallery />
                    </Marquee>
                </Row >
            </Container>
        </section>
    )
}
